import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import {
  getUsers as getUsersApi,
  updateDeviceCountApi,
  updateDeviceCountGloballyApi,
  updateUserStatusApi,
} from "../../helpers/api/users";

// constants
import { UserActionTypes } from "./constants";
import {
  getUserData,
  UsersApiResponseSuccess,
  UsersDataApiResponseError,
} from "./actions";

function* getUsersDatas({ payload: { type } }: any): SagaIterator {
  try {
    const response = yield call(getUsersApi, type);
    const users = response?.data

    yield put(UsersApiResponseSuccess(UserActionTypes.GET_USER_DATA, users));
  } catch (error: any) {
    yield put(UsersDataApiResponseError(UserActionTypes.GET_USER_DATA, error));
  }
}

function* updateUserStatuss({ payload: { id, value } }: any): SagaIterator {
  try {
    const response = yield call(updateUserStatusApi, { id, value });
    const message = response?.data?.message;

    yield put(
      UsersApiResponseSuccess(UserActionTypes.UPDATE_USER_STATUS, message)
    );
    yield put(getUserData(""));
  } catch (error: any) {
    yield put(
      UsersDataApiResponseError(UserActionTypes.UPDATE_USER_STATUS, error)
    );
  }
}
function* updateDeviceCount({
  payload: { userId, count, filter },
}: any): SagaIterator {
  try {
    const response = yield call(updateDeviceCountApi, { userId, count });
    const message = response?.data?.message;

    yield put(
      UsersApiResponseSuccess(UserActionTypes.UPDATE_DEVICE_COUNT, message)
    );
    yield put(getUserData(filter));
  } catch (error: any) {
    yield put(
      UsersDataApiResponseError(UserActionTypes.UPDATE_DEVICE_COUNT, error)
    );
  }
}

function* updateDeviceCountGlobally({
  payload: { value, filter },
}: any): SagaIterator {
  try {
    const response = yield call(updateDeviceCountGloballyApi, { value });
    const message = response?.data?.message;

    yield put(
      UsersApiResponseSuccess(
        UserActionTypes.UPDATE_DEVICE_COUNT_GLOBALLY,
        message
      )
    );
    yield put(getUserData(filter));
  } catch (error: any) {
    yield put(
      UsersDataApiResponseError(
        UserActionTypes.UPDATE_DEVICE_COUNT_GLOBALLY,
        error
      )
    );
  }
}

export function* watchGetUsers() {
  yield takeEvery(UserActionTypes.GET_USER_DATA, getUsersDatas);
}

export function* watchUpdateUserStatus() {
  yield takeEvery(UserActionTypes.UPDATE_USER_STATUS, updateUserStatuss);
}

export function* watchUpdateDeviceCount() {
  yield takeEvery(UserActionTypes.UPDATE_DEVICE_COUNT, updateDeviceCount);
}

export function* watchUpdateDeviceCountGlobally() {
  yield takeEvery(
    UserActionTypes.UPDATE_DEVICE_COUNT_GLOBALLY,
    updateDeviceCountGlobally
  );
}

function* UsersSaga() {
  yield all([
    fork(watchGetUsers),
    fork(watchUpdateUserStatus),
    fork(watchUpdateDeviceCount),
    fork(watchUpdateDeviceCountGlobally),
  ]);
}

export default UsersSaga;
